import React from 'react'
import { Formik } from 'formik'
import * as Yup from 'yup'
import MediaQuery from 'react-responsive'
import TextField from '@mui/material/TextField'
import Button from '@mui/material/Button'
import IncomeAndExpensesImage from '../../images/incomeandexpenses.svg'
import { YesOrNoRadioInput } from '../../atoms/yesOrNoRadioInput'
import * as S from './styles'

const IncomeAndExpensesSchema = Yup.object().shape({
		grossIncome: Yup.number()
			.min(0, 'O valor não pode ser inferior a 0.')
			.required('Preencha este campo.'),
		paysINSS: Yup.string().required('Selecione uma opção'),
		paysPGBL: Yup.string().required('Selecione uma opção'),
		previdencyYearlyContribution: Yup
			.number().when('paysPGBL', {
				is: 'Sim',
				then: Yup.number().min(0, 'O valor não pode ser inferior a 0.').required('Preencha este campo.')
			}),
		averageMedicalYearlyExpenses: Yup.number()
			.min(0, 'O valor não pode ser inferior a 0.')
			.required('Preencha este campo.'),
		ownEducationYearlyExpenses: Yup.number().min(0, 'O valor não pode ser inferior a 0.').required('Preencha este campo.'),
		paysAlimony: Yup.string().required('Selecione uma opção'),
		alimonyYearlyExpenses: Yup
			.number().when('paysAlimony', {
				is: 'Sim',
				then: Yup.number().min(0, 'O valor não pode ser inferior a 0.').required('Preencha este campo.')
			}),
})

export function IncomeAndExpenses({ data, setData, setStepState, stepState }) {
	const isStepDone = (values) => {
		return true;
	}

	return (<Formik
	validateOnBlur={false}
	validateOnChange={false}
	initialValues={data}
	validationSchema={IncomeAndExpensesSchema}
	onSubmit={(values) => {
		setData({ ...data, ...values})
		const enable = stepState.enable > 1 ? stepState.enable : 1
		setStepState({
			index: 1,
			enable
		})
	}}
	>
		{({ values, errors, handleChange, handleSubmit, dirty }) => (<>
			<S.Container>
				<S.Form>
					<TextField
					fullWidth
					variant="filled"
					id="grossIncome" name="grossIncome" type="number"
					onChange={handleChange}
					label="Qual é sua renda bruta anual ?" value={values.grossIncome}
					error={!!errors.grossIncome} helperText={errors.grossIncome || ' '}/>

					<YesOrNoRadioInput 
						id="paysINSS"
						label="Você contribui com o INSS?*"
						value={values.paysINSS}
						handleChange={handleChange} 
						error={errors.paysINSS}
					/>
					<YesOrNoRadioInput 
						id="paysPGBL"
						label="Você contribui com previdência privada PGBL?*"
						handleChange={handleChange} 
						value={values.paysPGBL}
						error={errors.paysPGBL}
					/>

					{values.paysPGBL === 'Sim' && (
						<TextField
						fullWidth
						variant="filled"
						id="previdencyYearlyContribution" name="previdencyYearlyContribution" type="number"
						onChange={handleChange}
						label="Quanto contribui anualmente com a previdência?" value={values.previdencyYearlyContribution}
						error={!!errors.previdencyYearlyContribution} helperText={errors.previdencyYearlyContribution || ' '}/>
					)}

					<TextField
						fullWidth
						variant="filled"
						id="averageMedicalYearlyExpenses" name="averageMedicalYearlyExpenses" type="number"
						onChange={handleChange}
						label="Quanto gasta com despesas médicas por ano?" value={values.averageMedicalYearlyExpenses}
						error={!!errors.averageMedicalYearlyExpenses} helperText={errors.averageMedicalYearlyExpenses || ' '}/>

					<TextField
						fullWidth
						variant="filled"
						id="ownEducationYearlyExpenses" name="ownEducationYearlyExpenses" type="number"
						onChange={handleChange}
						label="Quanto gasta com sua própria educação por ano?" value={values.ownEducationYearlyExpenses}
						error={!!errors.ownEducationYearlyExpenses} helperText={errors.ownEducationYearlyExpenses || ' '}/>

					<YesOrNoRadioInput 
						id="paysAlimony"
						value={values.paysAlimony}
						label="Paga pensão alimentícia?"
						handleChange={handleChange} 
						error={errors.paysAlimony}
					/>
					
					{values.paysAlimony === 'Sim' && (
						<TextField
						fullWidth
						variant="filled"
						id="alimonyYearlyExpenses" name="alimonyYearlyExpenses" type="number"
						onChange={handleChange}
						label="Qual o valor de pensão alimentícia pago por ano?" value={values.alimonyYearlyExpenses}
						error={!!errors.alimonyYearlyExpenses} helperText={errors.alimonyYearlyExpenses || ' '}/>
					)}
				</S.Form>
				<MediaQuery query="(min-width: 1024px)">
					<S.BoxImage>

					</S.BoxImage>
				</MediaQuery>
			</S.Container>
			<S.Footer>
				<S.Hr/>
				<Button onClick={() => {
					if(window.mixpanel){
						window.mixpanel.track("Forward to step 2 button")
					}
					handleSubmit()
				}} disabled={!isStepDone(values)} variant="contained" color="primary">PRÓXIMO PASSO</Button>
			</S.Footer>
		</>)}
	</Formik>)
}
